"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.font = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var color_1 = require("./color");
var length_1 = require("./length");
var measure_unit_1 = require("./measure-unit");
var text_decoration_1 = require("./text-decoration");
exports.font = type_guard_1.props({
    lineHeight: type_guard_1.optional(type_guard_1.union([measure_unit_1.measureUnit, length_1.length])),
    letterSpacing: type_guard_1.optional(type_guard_1.union([measure_unit_1.measureUnit, length_1.length])),
    color: type_guard_1.optional(color_1.color.any),
    // START font
    size: type_guard_1.optional(measure_unit_1.measureUnit),
    family: type_guard_1.optional(type_guard_1.string()),
    style: type_guard_1.optional(type_guard_1.defaulted(type_guard_1.enums(['normal', 'italic', 'oblique']), 'normal')),
    weight: type_guard_1.optional(type_guard_1.defaulted(type_guard_1.enums([100, 200, 300, 400, 500, 600, 700, 800, 900, 'normal', 'bold', 'ligher', 'bolder']), 400)),
    // END font
    // START text
    decoration: type_guard_1.optional(text_decoration_1.textDecoration),
    align: type_guard_1.optional(type_guard_1.enums(['left', 'right', 'center'])),
    transform: type_guard_1.optional(type_guard_1.enums(['none', 'capitalize', 'uppercase', 'lowercase', 'full-width'])),
    whiteSpace: type_guard_1.optional(type_guard_1.enums(['nowrap', 'normal'])),
    wordBreak: type_guard_1.optional(type_guard_1.enums(['normal', 'break-all', 'break-word'])),
    overflow: type_guard_1.optional(type_guard_1.enums(['visible', 'hidden', 'scroll', 'auto'])),
    textOverflow: type_guard_1.optional(type_guard_1.enums(['clip', 'ellipsis']))
    // END text
});
